module.exports = new __parcel__URL__("black_belt_cover.6db2451f.jpg").toString();